var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outer"},[_c('div',{staticClass:"inner"},[_c('main',[_c('app-loading'),_c('p',[_vm._v(_vm._s(_vm.info))])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }